module.exports = __webpack_public_path__ + "img/INTERIOR-SCROSS-6.f22135c3.jpg";